/**
 * Format a chord string with unicode modifiers (♯ and ♭).
 */
export function formatChordDisplay(symbol: string): string {
  return symbol.replace(/#/g, "♯").replace(/b/g, "♭");
}

/**
 * Normalize unicode musical symbols to ASCII (#/b).
 */
export function normalizeChordSymbol(symbol: string): string {
  return symbol.replace(/♯/g, "#").replace(/♭/g, "b").trim();
}
